import { useEffect, useRef } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

import { clientProfile } from "@/mocks/home";
import kundenstimmeAsset from "@/assets/home-kundenstimme-wohnzimmer.png";
const kundenstimmeImage = kundenstimmeAsset;

gsap.registerPlugin(ScrollTrigger);


export default function ClientProfileSection() {
  const sectionRef = useRef<HTMLElement>(null);
  const cardRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!clientProfile.hasRealQuote) return;

    const section = sectionRef.current;
    const card = cardRef.current;
    if (!section || !card) return;

    const content = card.querySelector("[data-content]");
    const image = card.querySelector("[data-image]");

    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: section,
        start: "top 80%",
        toggleActions: "play none none none",
      },
    });

    tl.fromTo(
      content,
      { x: -40, opacity: 0 },
      { x: 0, opacity: 1, duration: 0.9, ease: "power3.out" }
    );

    tl.fromTo(
      image,
      { x: 40, opacity: 0, scale: 1.05 },
      { x: 0, opacity: 1, scale: 1, duration: 0.9, ease: "power3.out" },
      "-=0.6"
    );

    return () => {
      tl.scrollTrigger?.kill();
      tl.kill();
    };
  }, []);

  if (!clientProfile.hasRealQuote) return null;

  return (
    <section ref={sectionRef} className="bg-background-100 py-20 md:py-28 lg:py-36 px-6 md:px-10 lg:px-14">
      <div className="max-w-7xl mx-auto">
        <div
          ref={cardRef}
          className="bg-background-50 rounded-2xl overflow-hidden grid grid-cols-1 lg:grid-cols-2"
        >
          <div data-content className="p-8 md:p-12 flex flex-col justify-center">
            <span className="inline-block px-3 py-1 bg-accent-100 text-accent-700 rounded-full text-xs font-medium mb-4 w-fit">
              {clientProfile.tag}
            </span>
            <div className="flex items-start gap-2 mb-1">
              <i className="ri-double-quotes-l text-3xl text-accent-500/40 flex-shrink-0 leading-none"></i>
              <h3 className="font-heading font-bold uppercase text-xl md:text-2xl text-foreground-950 leading-tight italic">
                {clientProfile.title}
              </h3>
            </div>
            <p className="mt-4 text-foreground-600 text-sm leading-relaxed">
              {clientProfile.description}
            </p>
            <a
              href="/referenzen"
              className="inline-flex items-center mt-6 px-6 py-3 rounded-full bg-accent-500 text-white text-sm font-medium hover:bg-accent-600 transition-colors w-fit"
            >
              Weitere Referenzen
            </a>
          </div>
          <div data-image className="relative h-64 lg:h-auto overflow-hidden">
            <img
              src={kundenstimmeImage}
              alt="Gemütlich beleuchtetes Wohnzimmer mit moderner Smart-Home-Beleuchtung am Abend"
              loading="lazy"
              decoding="async"
              className="w-full h-full object-cover"
            />

          </div>
        </div>
        <div className="mt-8 text-center">
          <a
            href="/referenzen"
            className="inline-flex items-center px-6 py-3 rounded-full border border-foreground-950 text-foreground-950 text-sm font-medium hover:bg-foreground-950 hover:text-white transition-colors"
          >
            Weitere Berichte
          </a>
        </div>
      </div>
    </section>
  );
}